export const messages = {
  placeholder: {
    id: 'admin/promotions.form.benefit.gift.selector.placeholder',
  },
}
